module.exports = __webpack_public_path__ + "static/media/gbp.18f10415.svg";